<div *ngIf="votingControl.voting" class="navigation-container">
  <div *ngIf="votingController.isVotingSelectionValid && votingController.emptySections.length" class="empty-sections-warning card-shadow">
    <span class="material-icons warning-icon">error_outline</span>
    <span>Du hast in <span class="empty-sections">{{votingController.emptySections.join(', ')}}</span> keine Option ausgewählt, möchtest du wirklich schon abstimmen?</span>
  </div>
  <div *ngIf="votingControl.reviewVoteMode" class="review-vote card-shadow">
    <span class="material-icons icon check">check_circle_outline</span>
    <div class="content">
      <span [innerHTML]="votingControl.voting.description.review"></span>
      <!--<app-sharing-buttons [bottomBar]="true" [withoutText]="true" [smallScreenSize]="true" [entityId]="votingControl.voting.info.newsid"></app-sharing-buttons>-->
    </div>
  </div>

  <div *ngIf="votingControl.submissionMode" class="submit-container">
    <div #captchaContainer class="captcha"></div>
    <button (click)="submitVote()"
            [disabled]="!votingController.isVotingSelectionValid || !captchaService.captchaFulfilled"
            mat-flat-button color="accent">Abstimmen
    </button>
  </div>
  <!--<button *ngIf="votingControl.resultsMode" (click)="shareVoting()" mat-flat-button color="accent">Abstimmung teilen</button>-->
</div>

<div *ngIf="votingControl.voteFailed" class="review-vote error card-shadow">
  <span class="material-icons icon check">how_to_vote</span>
  <div class="content">
    <span>Da hat leider etwas nicht geklappt! Bitte <a href="#" (click)="reloadPage()">lade die Seite neu</a> und versuche es erneut.</span>
  </div>
</div>
